import { Component, OnInit } from '@angular/core';
import {AngularFireAuth} from '@angular/fire/auth';
import {CardService} from '../../shared/card.service';
import {CouponService} from '../../shared/coupon.service';
import {AngularFirestore} from '@angular/fire/firestore';
import {Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { IPayPalConfig, ICreateOrderRequest } from 'ngx-paypal';

@Component({
  selector: 'app-servizi',
  templateUrl: './servizi.component.html',
  styleUrls: ['./servizi.component.css']
})
export class ServiziComponent implements OnInit {

  constructor(public afAuth: AngularFireAuth , private cardService: CardService,
              private couponService: CouponService,
              private firestore: AngularFirestore, public router: Router,
              private modalService: NgbModal ) { }

  public payPalConfig?: IPayPalConfig;
  price;
  dettagli;
  card;
  couponmailattivo;
  coupon_percent;
  f;
  prezzoscontato;
    user: any = {};
    utente: any = {};
    cardcoupon: any = {}; //inserito dall utente
    couponsaved: any = {};
    inpromotion: any = {};
  ngOnInit(){
      // card iniziali
      this.ReturnCard();
      // coupondb couponsaved
      this.ReturnCoupon();
      this.initConfig();
  }

  ngOnChanges(couponGenericoFlag){
      if (couponGenericoFlag === 1) {
          let flag;
          let indice;
          for (this.f = 0; this.f < this.couponsaved.length; this.f++) {
              if (this.inpromotion.code === this.couponsaved[this.f].payload.doc.data().code && this.couponsaved[this.f].payload.doc.data().mail === this.inpromotion.mail) {
                  flag = 1;
                  indice = this.f;
              }
          }
          if (flag === 1) {
              this.prezzoscontato = 1;
              this.coupon_percent = this.couponsaved[indice].payload.doc.data().percent;
              this.couponmailattivo = 1;
              alert('Coupon valido!');
          }
          else {
              alert('Coupon non valido!');
          }
      }
      else {
          let flag;
          for (this.f = 0; this.f < this.couponsaved.length; this.f++) {
              //this.cardcoupon.mail === this.couponsaved[this.f].payload.doc.data().mail &&
              if (this.cardcoupon.code === this.couponsaved[this.f].payload.doc.data().code) {
                  flag = 1;
              }
          }
          if (flag === 1) {
              this.couponmailattivo = 1;
              alert('Coupon  valido!');
              this.ReturnCardCoupon();
          }
          else {
              alert('Coupon non valido!');
          }
      }
  }



    ReturnCoupon = () => this.cardService
        .getCoupon()
        .subscribe(res => {
            (this.couponsaved = res);
        });
    ReturnCard = () => this.cardService
        .getCoffeeOrders()
        .subscribe(res => (this.card = res));
    ReturnCardCoupon = () => this.cardService
        .getCoffeeOrdersCoupon().subscribe(res => (this.card = res));


    CaricaCoupon(couponGenericoFlag) {
        this.ngOnChanges(couponGenericoFlag);
    }


    open(content, argprice, argtitle) {
        this.price = argprice;
        this.utente.pacchetto = argtitle;
        this.modalService.open(content);
    }
    openDettagli(content, argdettagli) {
        this.dettagli = argdettagli;
        this.modalService.open(content);
    }
    openCoupon(couponcontent) {
        this.modalService.open(couponcontent);
    }
    openMail(content, argtitle) {
        this.modalService.open(content);
        this.utente.pacchetto = argtitle;
    }
    openPromozione(promozionecontent) {
        this.modalService.open(promozionecontent);
    }

    InviaMail(){

        return new Promise((resolve, reject) => {
            this.firestore
                .collection('submissions')
                .add(this.utente)
                .then(res => {
                    console.log(this.utente);
                    alert('Grazie per la tua richiesta! Entro 72 ore riceverai la mail con i dettagli per il tuo servizio scelto.');
                    window.location.reload();
                }, err => reject(err));
        });
    }


  private initConfig(): void {
      //console.log(this.price);
      this.payPalConfig = {
          currency: 'EUR',
          //clientId: 'AatuzW_dm2K7y5P4WRE5ZT6xnDZW7ZfwS551X9bCWPENuQTs5Zi4h3AMKPVAlINGW9_80Z58Emx9aUMe',
          clientId: 'AeDQJ6F30Fkbxe1QLda56SlOC8JofaDAAEIz86DDJw1mO1HvpkGpipKTFMMvrqbzRyAprtOt7UZvfSY9',
          createOrderOnClient: (data) => ({
              intent: 'CAPTURE',
              purchase_units: [
                  {
                      amount: {
                          currency_code: 'EUR',
                          value: this.price,
                          breakdown: {
                              item_total: {
                                  currency_code: 'EUR',
                                  value: this.price
                              }
                          }
                      },
                      items: [
                          {
                              name: 'Enterprise Subscription',
                              quantity: '1',
                              category: 'DIGITAL_GOODS',
                              unit_amount: {
                                  currency_code: 'EUR',
                                  value: this.price,
                              },
                          }
                      ]
                  }
              ]
          }),
          advanced: {
              commit: 'true'
          },
          style: {
              label: 'buynow',
              size: 'responsive',
              layout: 'horizontal',
              color: 'blue',
          },
          onApprove: (data, actions) => {
              console.log('onApprove - transaction was approved, but not authorized', data, actions);
              actions.order.get().then(details => {
                  console.log('onApprove - you can get full order details inside onApprove: ', details);
              });
          },
          onClientAuthorization: (data) => {
              console.log('onClientAuthorization - you should probably inform your server about completed transaction at this point', data);
              return new Promise((resolve, reject) => {
                  this.firestore
                      .collection('submissions')
                      .add(this.utente)
                      .then(res => {
                          console.log(this.utente);
                          alert('Grazie per la tua richiesta! Entro 72 ore riceverai la mail con i dettagli per il tuo servizio scelto.');
                          window.location.reload();
                      }, err => reject(err));
              });
          },
          onCancel: (data, actions) => {
              console.log('OnCancel', data, actions);
          },
          onError: err => {
              console.log('OnError', err);
          },
          onClick: (data, actions) => {
              console.log('onClick', data, actions);
          },
      };
  }
}

